module.exports = __webpack_public_path__ + "img/suone_2.530ddc18.jpg";